import { useQuery } from "@tanstack/react-query";
import { qpcrApi } from "@/api/qpcr";

export function useOpticsForDevice(deviceId: string, limit = 25) {
  return useQuery({
    queryKey: ["device", deviceId, "optics", limit],
    queryFn: () => qpcrApi.listForDevice(deviceId, limit),
    enabled: !!deviceId,
  });
}

export function useOptic(opticId: string) {
  return useQuery({
    queryKey: ["optic", opticId],
    queryFn: () => qpcrApi.detail(opticId),
    enabled: !!opticId,
    staleTime: Infinity,
  });
}

export function useOpticDump(opticId: string, enabled: boolean) {
  return useQuery({
    queryKey: ["optic", opticId, "dump"],
    queryFn: () => qpcrApi.dump(opticId),
    enabled: !!opticId && enabled,
    staleTime: Infinity,
  });
}

export function usePathogens() {
  return useQuery({
    queryKey: ["pathogens"],
    queryFn: () => qpcrApi.pathogens(),
    staleTime: 5 * 60_000,
  });
}
